"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=function(e,r,t){return r in e?Object.defineProperty(e,r,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[r]=t,e};
